import { Tree } from 'antd';
import React, { FC, ReactText } from 'react';

type DataNode = any;

type Props = {
  selectedKey: string;
  treeStructure: DataNode[];
  disabled: boolean;
  onNodeSelected: (nodeKey: string) => void;
};

const TreeView: FC<Props> = ({ disabled, selectedKey, treeStructure, onNodeSelected }) => {
  const onSelect = (
    selectedKeys: ReactText[],
    info: {
      event: 'select';
      selected: boolean;
      node: any;
      selectedNodes: DataNode[];
      nativeEvent: MouseEvent;
    }
  ) => {
    if (!(selectedKeys && selectedKeys.length)) {
      return;
    }

    const selectedKey = selectedKeys[0] as string;
    onNodeSelected(selectedKey);
  };

  return <Tree selectedKeys={[selectedKey]} defaultExpandAll={true} disabled={disabled} showLine treeData={treeStructure} onSelect={onSelect} />;
};

export default TreeView;
